<template>
  <notice-form is-edit :data="noticeInfo" @save="handleSubmit" />
</template>

<script>
import NoticeForm from "@/components/notice-form/NoticeForm";
import {request} from "@/config/request";
export default {
  name: "NoticeEdit",
  components: {NoticeForm},
  data() {
    return {
      noticeInfo: {}
    }
  },
  methods: {
    async handleSubmit(data) {
      try {
        const form = {...this.noticeInfo};
        delete form.createTime;
        delete form.updateTime;
        const params = Object.assign(form, data);
        await request(this.$api.notice.update, params);
        this.$message.success('操作成功');
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.notice.detail, this.$route.query);
        this.noticeInfo = res.notice;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.el-form {
  max-width: 700px;
}

</style>
